/*
 * @Author: zhangjun
 * @Date: 2023-06-20 17:27:56
 * @LastEditors: zhangjun
 * @LastEditTime: 2023-06-27 10:34:03
 * @Description:
 * @FilePath: /src/serverice/api.js
 */
import request from "./request";
import requestDC from "./request-dc";
import requestTDP from "./request-tdp";
import requestTTDP from "./request-ttdp";
import requestGoogleorota from "./request-googleorota";
import hmacSHA256 from "crypto-js/hmac-sha256";
import encHex from "crypto-js/enc-hex";
import qs from "qs";
// export function getApk() {
//   return request({
//     url: `/xr-system-api/xr/apk/v1/domesticDownload`,
//     method: "post",
//     data: {},
//   });
// }
export function getApk () {
  var clientType = "FFALCON-XR-TAURUS-1";
  // var deliveryChannelCode = "FFALCON";
  var appId = "com.tcl.xrmanager.main";
  var systemversion = "10";
  var mac = "00:00:00:00:00:00";
  var dnum = "00000000";
  var resourceList = [{
      "packageName": "com.tcl.xrmanager.main",
      "versionCode": 1
  }]

  let appSecret

  // 本地代理测试
  if (['test.rayneo.cn', 'localhost'].includes(window.location.hostname)) {
      appSecret = "2CE0AFE84819A201"; // 测试环境
  } else {
      appSecret = "2CE5E939F7AE7191"; // 生产环境
  }

  const signature = hmacSHA256(
      `appId=${appId}&clientType=${clientType}&dnum=${dnum}&mac=${mac}&resourceList=${JSON.stringify(
          resourceList
      )}&systemversion=${systemversion}&appSecret=${appSecret}`,
      appSecret
  )
      .toString(encHex)
      .toUpperCase();

  // 测试环境请求接口：http://tdp-t.api.leiniao.com/tdp-api/f-operate/v1/getOperateUpgradeList
  // 正式环境请求接口：http://tdp-o.api.leiniao.com/tdp-api/f-operate/v1/getOperateUpgradeList

  // let url = ''

  // if (['test.rayneo.cn', 'localhost'].includes(window.location.hostname)) {
  //     // url = '/tdp-api/f-operate/v1/getOperateUpgradeList'
  //     url = 'http://tdp-t.api.leiniao.com/tdp-api/f-operate/v1/getOperateUpgradeList'
  // } else {
  //     url = 'http://tdp-o.api.leiniao.com/tdp-api/f-operate/v1/getOperateUpgradeList'
  // }
  return requestTTDP({
    url: '/tdp-api/f-operate/v2/getOperateUpgradeList',
    method: "post",
    data: {
      appId,
      clientType,
      dnum,
      mac,
      resourceList,
      systemversion,
      signature,
    },
  });

  // let param = {
  //     appId,
  //     clientType,
  //     dnum,
  //     mac,
  //     resourceList,
  //     systemversion,
  //     signature,
  // }

  // $.ajax({
  //     url: url,
  //     type: 'POST',
  //     contentType: "application/json",
  //     dataType: "json",
  //     data: JSON.stringify(param),
  //     success: function (res) {
  //         console.log("res", res)
  //         window.location.href = res.data[0].ossUrl;
  //     }
  // })

}

export function getInstrution() {
  return request({
    url: `/xr-system-api/xr/instruction/v1/getXrInstruction`,
    method: "post",
    data: {},
  });
}
export function getXrApk(clientType) {
  const appSecret = ['hw-test.rayneo.cn'].includes(window.location.hostname) ? "2CE0AFE84819A201" : "2CE5E939F7AE7191";
  const appId = "com.tcl.xrmanager.main";
  const dnum = "1";
  const mac = "D1:AA:59:19:E9:61";
  const resourceList = [
    {
      packageName: "com.tcl.xrmanager.main",
      versionCode: 0,
    },
  ];
  const systemversion = "1";
  const signature = hmacSHA256(
    `appId=${appId}&clientType=${clientType}&dnum=${dnum}&mac=${mac}&resourceList=${JSON.stringify(
      resourceList
    )}&systemversion=${systemversion}&appSecret=${appSecret}`,
    appSecret
  )
    .toString(encHex)
    .toUpperCase();
  return requestTDP({
    url: `/tdp-api/f-operate/v1/getOperateUpgradeList`,
    method: "post",
    data: {
      appId,
      clientType,
      dnum,
      mac,
      resourceList,
      systemversion,
      signature,
    },
  });
}
// 2）测试环境：https://dc-t.api.leiniao.com

//       生产环境：https://dc-o.api.leiniao.com
// 3、访问页面行为："bottType":"download_view","bottName":"view_load"

//       点击下载行为："bottType":"download_view","bottName":"click_download"
export function frontReport(bottName) {
  requestDC({
    url: `/frontreport/custom`,
    method: "post",
    headers: { "content-type": "application/x-www-form-urlencoded" },
    data: qs.stringify({
      basicInfo: JSON.stringify({
        userId: "584f9c5bab31fb1d59e138e1",
        projectId: "62902f81afae46c6a4a8dc1aa90ea4b5",
      }),
      dataInfo: JSON.stringify({
        phone_type: "",
        bottType: "download_view",
        bottName,
        glasses_id: "00000000",
        type: "36F862DB45",
        event_time: Date.now(),
        phone_id: "",
      }),
    }),
  });
}

export function getGoogleorota() {
  return requestGoogleorota({
    url: '/xrlauncherhwapi/v1/data/dict/getContent',
    method: 'get',
    params: {
      parentTag: 'HWxrappDownloadConfig',
      tag: 'is_googleorota'
    }
  })
}
